<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div class="vx-row md:w-full">

            <vx-tooltip class="position-icon" :text="$t('button.details')" position="top">
                <feather-icon icon="EyeIcon" class="action-success icon-btn mt-3"
                              svg-classes="h-5 w-5 hover:text-primary cursor-pointer" @click="editRecord">
                </feather-icon>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.delete')" position="top">
                <feather-icon icon="TrashIcon" class="action-err icon-btn mt-3"
                              svg-classes="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord">
                </feather-icon>
            </vx-tooltip>
        </div>
        <vs-popup class="holamundo"  title="Thông tin phòng ban" :active.sync="openDepartmentDetails" v-if="openDepartmentDetails" id="details-department">
            <DepartmentInfo :departmentId="params.data.id" :branchId="params.data.organizationBranchId"></DepartmentInfo>
        </vs-popup>
    </div>
</template>
<script>
import DepartmentInfo from "../DepartmentInfo";
export default {
    name:'CellRendererActions',
    components: {
        DepartmentInfo
    },
    data() {
        return {
            openDepartmentDetails: false,
        }
    },
    methods:{
        editRecord(){
            // this.$router.push(`/user/department-info?branchId=${this.params.data.organizationBranchId}&departmentId=${this.params.data.id}`).catch(() => {
            // })
            this.openDepartmentDetails = true;
        },
        confirmDeleteRecord(){
            this.$vs.dialog({
                type:'confirm',
                color:'danger',
                title: 'Xác nhận xoá',
                text:`Bạn có chắc là muốn xoá phòng ban "${this.params.data.departmentName}" không? `,
                accept: this.deleteRecord,
                acceptText:'Xoá',
                cancelText:'Huỷ',
            })
        },
        deleteRecord(){
            this.$vs.loading();
            this.$crm.post('/department/delete/' + this.params.data.id).then(() => {
                this.$vs.loading.close();
                this.showDeleteSuccess();
                this.$store.commit('DELETE_DEPARTMENT', true)
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color:'danger'
                });
            });
        },
        showDeleteSuccess(){
            this.$vs.notify({
                color:'success',
                text:'Xoá thành công',
                iconPack: 'feather',
                icon:'icon-alert-circle',
            })
        }
    },

    mounted() {
        this.$eventBus.$on('update-department-success', () => {
            this.openDepartmentDetails = false;
            this.$store.commit('DELETE_DEPARTMENT', true)
        })
    }
}
</script>

<style lang="scss">
#details-department {
    .vs-popup {
        width: 1400px !important;
    }
}
</style>
